module.exports = __webpack_public_path__ + "img/so.580972ed.svg";